export const ROLE_TYPES = {
  purchaser: '1',
  editor: '3',
  author: '4',
  reader: '5',
  guest: '6',
}

export const ROLE_TYPES_REVERSE = {
  1: 'purchaser',
  3: 'editor',
  4: 'author',
  5: 'reader',
  6: 'guest',
}

export const ROLES = {
  purchaser: {
    id: 'purchaser',
    value: 1,
    label_en: 'Purchaser',
    label_de: 'Purchaser',
    description_en: 'The user who purchased a book.',
    description_ge: 'The user who purchased a book.',
  },
  editor: {
    id: 'editor',
    value: 3,
    label_en: 'Editor',
    label_de: 'Editor/-in',
    description_en:
      'An Editor can add and sort story prompts, edit any submitted story, and invite authors and readers.',
    description_ge:
      'kann Story-Eingabeaufforderungen hinzufügen und sortieren, jede eingereichte Geschichte bearbeiten und Autoren bzw. Autorinnen und Leser bzw. Leserinnen einladen.',
  },
  author: {
    id: 'author',
    value: 4,
    label_en: 'Author',
    label_de: 'Autor/-in',
    description_en:
      'An Author will be asked by email to provide a response to every story prompt, unless you change their role for a specific story prompt.',
    description_ge:
      'wird standardmäßig aufgefordert, eine Antwort auf jede Schreibanregung zu geben, es sie denn, Sie ändern dies bei einer bestimmten Schreibanregung.',
  },
  reader: {
    id: 'reader',
    value: 5,
    label_en: 'Reader',
    label_de: 'Leser/-in',
    description_en:
      'A Reader can read all story prompt responses, unless you change their role for a specific story prompt.',
    description_ge:
      'kann standardmäßig alle eingereichte Geschichten lesen, es sie denn, Sie ändern dies bei einer bestimmten Schreibanregung.',
  },
  guest: {
    id: 'guest',
    value: 6,
    label_en: 'Guest',
    label_de: 'Gast',
    description_en:
      'A guest has no specific access until you change their access per story prompt.',
    description_ge:
      'Ein Gast hat keinen spezifischen Zugriff, bis Sie seinen Zugriff per Story-Eingabeaufforderung ändern.',
  },
  none: {
    id: 'none',
    value: 7,
    label_en: 'None',
    label_de: 'keine',
    description_en: 'No access to the prompt.',
    description_ge: 'No access to the prompt.',
  },
}

export const ASSIGNABLE_ROLES = {
  editor: {
    id: 'editor',
    value: 3,
    label_en: 'Editor',
    label_de: 'Editor/-in',
    description_en:
      'An Editor can add and sort story prompts, edit any submitted story, and invite authors and readers.',
    description_ge:
      'kann Story-Eingabeaufforderungen hinzufügen und sortieren, jede eingereichte Geschichte bearbeiten und Autoren bzw. Autorinnen und Leser bzw. Leserinnen einladen.',
  },
  author: {
    id: 'author',
    value: 4,
    label_en: 'Author',
    label_de: 'Autor/-in',
    description_en:
      'An Author will be asked by email to provide a response to every story prompt, unless you change their role for a specific story prompt.',
    description_ge:
      'wird standardmäßig aufgefordert, eine Antwort auf jede Schreibanregung zu geben, es sie denn, Sie ändern dies bei einer bestimmten Schreibanregung.',
  },
  reader: {
    id: 'reader',
    value: 5,
    label_en: 'Reader',
    label_de: 'Leser/-in',
    description_en:
      'A Reader can read all story prompt responses, unless you change their role for a specific story prompt.',
    description_ge:
      'kann standardmäßig alle eingereichte Geschichten lesen, es sie denn, Sie ändern dies bei einer bestimmten Schreibanregung.',
  },
  guest: {
    id: 'guest',
    value: 6,
    label_en: 'Guest',
    label_de: 'Gast',
    description_en:
      'A guest has no specific access until you change their access per story prompt.',
    description_ge:
      'Ein Gast hat keinen spezifischen Zugriff, bis Sie seinen Zugriff per Story-Eingabeaufforderung ändern.',
  },
}

export const BOOK_STORY_FILTERS = {
  queued: {
    id: 'queued',
    value: 1,
    label_en: 'Queued Prompts',
    label_de: 'Eingabeaufforderungen in der Warteschlange',
  },
  shared: {
    id: 'shared',
    value: 2,
    label_en: 'Shared Stories',
    label_de: 'Geteilte Geschichten',
  },
  notshared: {
    id: 'notshared',
    value: 3,
    label_en: 'Stories Not Shared',
    label_de: 'Nicht geteilte Geschichten',
  },
  mystories: {
    id: 'mystories',
    value: 4,
    label_en: 'My Stories',
    label_de: 'Meine Geschichten',
  },
}

export const BOOK_STORY_AUTHOR_FILTERS = {
  mystories: {
    id: 'mystories',
    value: 1,
    label_en: 'My Stories',
    label_de: 'Meine Geschichten',
  },
  mynotshared: {
    id: 'mynotshared',
    value: 2,
    label_en: 'My Stories not shared',
    label_de: 'Meine Geschichten nicht geteilt',
  },
}

export const BOOK_SETUP_GUIDE_STORIES = {
  adventure: {
    id: 'adventure',
    value: 1,
    label_en: 'Adventure',
    label_de: 'Abenteuer',
  },
  history: {
    id: 'history',
    value: 2,
    label_en: 'History',
    label_de: 'Geschichte',
  },
  recommended: {
    id: 'recommended',
    value: 3,
    label_en: 'Recommended',
    label_de: 'Empfohlen',
  },
  advice: {
    id: 'advice',
    value: 4,
    label_en: 'Advice',
    label_de: 'Geschichte',
  },
  life: {
    id: 'life',
    value: 5,
    label_en: 'Life',
    label_de: 'Geschichte',
  },
  religion: {
    id: 'religion',
    value: 6,
    label_en: 'Religion',
    label_de: 'Geschichte',
  },
  art: {
    id: 'art',
    value: 7,
    label_en: 'Art',
    label_de: 'Kunst',
  },
  marriage: {
    id: 'marriage',
    value: 8,
    label_en: 'Marriage',
    label_de: 'Ehe',
  },
  school: {
    id: 'school',
    value: 9,
    label_en: 'School',
    label_de: 'Schule',
  },
  childhood: {
    id: 'childhood',
    value: 10,
    label_en: 'Childhood',
    label_de: 'Kindheit',
  },
  military: {
    id: 'military',
    value: 11,
    label_en: 'Military',
    label_de: 'militärisch',
  },
  siblings: {
    id: 'siblings',
    value: 12,
    label_en: 'Siblings',
    label_de: 'Geschwister',
  },
  divorce: {
    id: 'divorce',
    value: 13,
    label_en: 'Divorce',
    label_de: 'Scheidung',
  },
  moving: {
    id: 'moving',
    value: 14,
    label_en: 'Moving',
    label_de: 'Ziehen um',
  },
  training: {
    id: 'training',
    value: 15,
    label_en: 'Training',
    label_de: 'Ausbildung',
  },
  family: {
    id: 'family',
    value: 16,
    label_en: 'Family',
    label_de: 'Familie',
  },
  national_service: {
    id: 'national_service',
    value: 17,
    label_en: 'National Service',
    label_de: 'Wehrdienst',
  },
  travel: {
    id: 'travel',
    value: 18,
    label_en: 'Travel',
    label_de: 'Reisen',
  },
  friends: {
    id: 'friends',
    value: 19,
    label_en: 'Friends',
    label_de: 'Freunde',
  },
  parents: {
    id: 'parents',
    value: 20,
    label_en: 'Parents',
    label_de: 'Eltern',
  },
  weekends: {
    id: 'weekends',
    value: 21,
    label_en: 'Weekends',
    label_de: 'Wochenenden',
  },
  grandchildren: {
    id: 'grandchildren',
    value: 22,
    label_en: 'Grandchildren',
    label_de: 'Enkelkinder',
  },
  politics: {
    id: 'politics',
    value: 23,
    label_en: 'Politics',
    label_de: 'Politik',
  },
  work: {
    id: 'work',
    value: 24,
    label_en: 'Work',
    label_de: 'Arbeit',
  },
}

export const HELP_DESK = {
  main: {
    en: 'https://help.anecdobio.com/',
    ge: 'https://hilfe.anecdobio.com/',
  },
  book_info: {
    en: 'https://help.anecdobio.com/KnowledgeBase/Details/?id=28-Overview-of-the-Book-Info-dashboard-section',
    ge: 'https://help.anecdobio.com/KnowledgeBase/Details/?id=28-Overview-of-the-Book-Info-dashboard-section',
  },
  friend_family: {
    en: 'https://help.anecdobio.com/KnowledgeBase/Details/?id=29-Overview-of-the-Friends-and-Family-dashboard-section',
    ge: 'https://help.anecdobio.com/KnowledgeBase/Details/?id=29-Overview-of-the-Friends-and-Family-dashboard-section',
  },
  story: {
    en: 'https://help.anecdobio.com/KnowledgeBase/Details/?id=30-Overview-of-the-Stories-dashboard-section',
    ge: 'https://help.anecdobio.com/KnowledgeBase/Details/?id=30-Overview-of-the-Stories-dashboard-section',
  },
  dashboard: {
    en: 'https://help.anecdobio.com/KnowledgeBase/Details/?id=31-What-is-the-Anecdobio-dashboard',
    ge: 'https://help.anecdobio.com/KnowledgeBase/Details/?id=31-What-is-the-Anecdobio-dashboard',
  },
}

export const DOCUMENT_LINKS = {
  privacy: {
    en: 'https://resource.anecdobio.com/privacy_en.html',
    ge: 'https://resource.anecdobio.com/privacy_ge.html',
  },
  terms: {
    en: 'https://resource.anecdobio.com/terms_en.html',
    ge: 'https://resource.anecdobio.com/terms_ge.html',
  },
  imprint: {
    en: 'https://resource.anecdobio.com/imprint_en.html',
    ge: 'https://resource.anecdobio.com/imprint_ge.html',
  },
}

//
// export const STRIPE_PRICE_IDS = {
//   publisher: {
//     en: 'price_1KK30GCceq9N4BQDhJcg7gLK',
//     ge: 'price_1KK39LCceq9N4BQDrE7jHFWR'
//   },
//   editor: {
//     en: 'price_1KK2ziCceq9N4BQDfuSKHWjA',
//     ge: 'price_1KK38jCceq9N4BQDmuKZMjSM'
//   },
//   author: {
//     en: 'price_1KK2yXCceq9N4BQDPiFNBb7u',
//     ge: 'price_1KK388Cceq9N4BQD1a8WBKJF'
//   }
// }
//
//
// export const STRIPE_PRICE_IDS_TEST = {
//   publisher: {
//     en: 'price_1JSO3hCceq9N4BQDPPt16TzG',
//     ge: 'price_1KLuaCCceq9N4BQDVUUaXdOm'
//   },
//   editor: {
//     en: 'price_1JSO1iCceq9N4BQDfPV0rPDf',
//     ge: 'price_1KLuYjCceq9N4BQDVLW8W4BU'
//   },
//   author: {
//     en: 'price_1JSO0dCceq9N4BQD5hwfL1sa',
//     ge: 'price_1KLuXJCceq9N4BQDnlNg5JK0'
//   }
// }
//
// export const STRIPE_SHIPPING_RATES_TEST = {
//     en: 'shr_1KMd5ICceq9N4BQDLdn8Z3SE',
//     ge: 'shr_1KMd6KCceq9N4BQDVROfcLnm'
// }

export const HELP_EMAILS = {
  main: {
    en: 'help@anecdobio.com',
    ge: 'hilfe@anecdobio.com',
  },
}

export const HOME_VIDEO = {
  link: {
    en: 'https://www.youtube.com/embed/3bSiz6q0q74?rel=0&amp',
    ge: 'https://www.youtube.com/embed/i0BA-kS8-n4?rel=0&amp',
  },
  id: {
    en: '3bSiz6q0q74',
    ge: 'i0BA-kS8-n4',
  },
}

export const AVAILABLE_LANGUAGES = ['en', 'de']

export const TUT_IDS = {
  addContrib: 'add-contrib',
  editStory: 'edit-story',
  addPrompt: 'add-prompt',
  bookInfo: 'info-section',
  storySection: 'story-section',
  expandStories: 'expand-stories',
}

export const EMAIL_RX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
